import { render, staticRenderFns } from "./DialogTaoPhieuThayDoiThongTin.vue?vue&type=template&id=650150cd&scoped=true"
import script from "./DialogTaoPhieuThayDoiThongTin.vue?vue&type=script&lang=js"
export * from "./DialogTaoPhieuThayDoiThongTin.vue?vue&type=script&lang=js"
import style0 from "./DialogTaoPhieuThayDoiThongTin.vue?vue&type=style&index=0&id=650150cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650150cd",
  null
  
)

export default component.exports